module.exports = __webpack_public_path__ + "static/media/aexpress.2f7bff60.svg";